import styled from 'styled-components';

export const List = styled.ul`
    margin: 0;
    padding-left: 1.15rem;
    font-size: 0.94rem;
    line-height: 1.55;
    color: var(--text);

    li {
        margin-bottom: 0.55rem;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const Label = styled.strong`
    font-weight: 700;
    color: var(--text);
`;
